import React from "react";
import { Button } from "react-bootstrap";


import "aos/dist/aos.css";
import Aos from "aos";

import MyVideo from "./mp4/backgroundvid.mp4";

const HeaderEdit = () => {
  function refreshPage() {
    window.location.reload(false);
  }
  return (
    <div className="w-100 bg-dark">
        <div className='bottom-text d-flex align-items-center'>
            <div className='w-100 m-0 p-0'>
               <img onClick={refreshPage} className="img-fluid logo-img mx-auto" src="./img/logoSmall.png"></img>
            </div>
        </div>
        <div className='header-bottom mx-auto'></div>  
    </div>
  );
};

export default HeaderEdit;
